import React from "react";
import { FieldType } from "../../shared/model/enumerations/field-type.model";
import { IField } from "../../shared/model/field.model";
import { InputAttached } from "./InputAttached";
import { InputMultipleChoice } from "./InputMultipleChoice";
import { InputText } from "./InputText";
import { InputSingleChoice } from "./InputSingleChoice";

interface IProps {
  formik: any;
  field: IField;
  index: number;
  errors: number[];
}
export const FormBuilder = (props: IProps) => {
  const { formik, field, index } = props;

  switch (props.field.fieldType) {
    case FieldType.TEXT:
      return <InputText formik={formik} field={field} indexField={index} errors={props.errors} />;
    case FieldType.ATTACHED:
      return <InputAttached formik={formik} field={field} indexField={index} errors={props.errors} />;
    case FieldType.MULTIPLE_CHOICE:
      return (
        <InputMultipleChoice formik={formik} field={field} indexField={index} errors={props.errors} />
      );
    case FieldType.SINGLE_CHOICE:
      return (
        <InputSingleChoice formik={formik} field={field} indexField={index} errors={props.errors} />
      );
    default:
      return <></>;
  }
};
